<div class="modal-header customBlueHeader">
  <p class="modal-title" *ngIf="assessmentData?.assessmentType == 'FRM_NRS_ASMT'">Nursing Assessment Form</p>
  <p class="modal-title" *ngIf="assessmentData?.assessmentType == 'FRM_PRE_ASMT'">Pre Assessment Form</p>
  <p class="modal-title" *ngIf="assessmentData?.assessmentType == 'FRM_PHY_ASMT'">Physio Assessment Form</p>

  <button type="but" class="close" aria-label="Close" (click)="modelClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body customModalBody" *ngIf="assessmentData?.assessmentType == 'FRM_PRE_ASMT'">
  <form [formGroup]="preAssessment_Form">
    <div class="form-container">
     

      <!-- Basic Information -->
      <h2>Basic Information</h2>
      <label for="name">Name:</label>
      <input type="text" id="name" name="name" placeholder="Enter name" disabled formControlName="name">

      <label for="age">Age:</label>
      <input type="number" id="age" name="age" placeholder="Enter age" disabled formControlName="age">

      <label for="gender">Gender:</label>
      <select id="gender" name="gender" formControlName="gender" disabled>
        <option value="">Select</option>
        <option value="2">Male</option>
        <option value="1">Female</option>
        <option value="3">Other</option>
      </select>

      <label for="contact">Contact Details:</label>
      <input type="text" id="contact" name="contact" disabled placeholder="Enter contact number"
        formControlName="contactDetails">

      <label for="email">Email (Optional):</label>
      <input type="email" id="email" name="email" disabled placeholder="Enter email" formControlName="eMail">

      <!-- Health Conditions -->
      <h2>Health Conditions</h2>
      <label>Does the elder suffer from any of the following:</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="sufferingFrom" value="high-blood-pressure"
            (change)="onCheckboxChange($event,'sufferingFrom')"> High Blood Pressure</label>
        <label><input type="checkbox" id="sufferingFrom" value="heart-disease"
            (change)="onCheckboxChange($event,'sufferingFrom')"> Heart Disease</label>
        <label><input type="checkbox" id="sufferingFrom" value="diabetes"
            (change)="onCheckboxChange($event,'sufferingFrom')"> Diabetes</label>
        <label><input type="checkbox" id="sufferingFrom" value="asthma"
            (change)="onCheckboxChange($event,'sufferingFrom')"> Asthma</label>
        <label><input type="checkbox" id="sufferingFrom" value="copd" (change)="onCheckboxChange($event,'sufferingFrom')">
          COPD</label>
        <label><input type="checkbox" id="sufferingFrom" value="arthritis"
            (change)="onCheckboxChange($event,'sufferingFrom')"> Arthritis</label>
        <label><input type="checkbox" id="sufferingFrom" value="kidney-disease"
            (change)="onCheckboxChange($event,'sufferingFrom')"> Kidney Disease</label>
        <label><input type="checkbox" id="sufferingFrom" value="other" (change)="onCheckboxChange($event,'sufferingFrom')">
          Others:</label>
        <input type="text" id="conditions-other" placeholder="Specify other conditions"
          formControlName="otherSufferingDis">
        <label><input type="checkbox" id="sufferingFrom" value="none" (change)="onCheckboxChange($event,'sufferingFrom')">
          None</label>
      </div>

      <label>Has the Elder been recently hospitalized or undergone surgery?</label>
      <div class="radio-group">
        <label><input type="radio" id="hospitalized" value="yes" formControlName="recentlyHospitalized"> Yes</label>
        <label><input type="radio" id="hospitalized" value="no" formControlName="recentlyHospitalized"> No</label>
      </div>
      <textarea id="hospitalized-details" name="hospitalized-details" placeholder="If yes, please specify"
        formControlName="hospitalizedDetails"></textarea>

      <label>Is the Elder under the care of a physician or specialist?</label>
      <div class="radio-group">
        <label><input type="radio" id="physician" value="yes" formControlName="underCarePhysician"> Yes</label>
        <label><input type="radio" id="physician" value="no" formControlName="underCarePhysician"> No</label>
      </div>
      <textarea id="physician-details" name="physician-details" formControlName="physicianCareDetails"
        placeholder="If yes, name and specialty of the doctor"></textarea>

      <label>What medications is the Elder currently taking?</label>
      <textarea id="medications" name="medications" placeholder="List medications"
        formControlName="prescriptionDetails"></textarea>

      <div class="file-upload">
        <label for="file-upload">Upload Medication File:</label>
        <input type="file" id="file-upload" name="file-upload"  (change)="uploadReports($event)">
        <label for="file-upload">Choose File</label>
      </div>

      <!-- Symptoms & Condition Management -->
      <h2>Symptoms & Condition Management</h2>
      <label>Does the Elder require regular monitoring of any of the following?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="regularMonitoring" value="blood-pressure"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Blood Pressure</label>
        <label><input type="checkbox" id="regularMonitoring" value="blood-sugar"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Blood Sugar Levels</label>
        <label><input type="checkbox" id="regularMonitoring" value="oxygen-saturation"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Oxygen Saturation</label>
        <label><input type="checkbox" id="regularMonitoring" value="weight-management"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Weight Management</label>
        <label><input type="checkbox" id="regularMonitoring" value="fluid-intake"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Fluid Intake & Output</label>
        <label><input type="checkbox" id="regularMonitoring" value="other"
            (change)="onCheckboxChange($event,'regularMonitoring')"> Others:</label>
        <input type="text" name="monitoring-other" placeholder="Specify other monitoring"
          formControlName="otherMonitoring">
        <label><input type="checkbox" id="regularMonitoring" value="none"
            (change)="onCheckboxChange($event,'regularMonitoring')"> None</label>
      </div>

      <label>Has the Elder experienced any of the following symptoms in the last 3 months?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="symptomsDetails" value="shortness-of-breath"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Shortness of breath</label>
        <label><input type="checkbox" id="symptomsDetails" value="chest-pain"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Chest pain or discomfort</label>
        <label><input type="checkbox" id="symptomsDetails" value="dizziness"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Frequent dizziness or fainting</label>
        <label><input type="checkbox" id="symptoms" value="swelling"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Swelling in legs or feet</label>
        <label><input type="checkbox" id="symptomsDetails" value="blood-sugar"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Uncontrolled blood sugar fluctuations</label>
        <label><input type="checkbox" id="symptomsDetails" value="joint-pain"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Joint pain or stiffness affecting movement</label>
        <label><input type="checkbox" id="symptomsDetails" value="breathing-difficulty"
            (change)="onCheckboxChange($event,'symptomsDetails')"> Difficulty in breathing at night</label>
        <label><input type="checkbox" id="symptomsDetails" value="falls" (change)="onCheckboxChange($event,'symptomsDetails')">
          Any recent falls or balance issues</label>
        <label><input type="checkbox" id="symptomsDetails" value="other" (change)="onCheckboxChange($event,'symptomsDetails')">
          Others:</label>
        <input type="text" name="symptoms-other" placeholder="Specify other symptoms" formControlName="otherSymptoms">
        <label><input type="checkbox" id="symptomsDetails" value="none" (change)="onCheckboxChange($event,'symptomsDetails')">
          None</label>
      </div>

      <!-- Mobility & Daily Living Assistance -->
      <h2>Mobility & Daily Living Assistance</h2>
      <label>Does the Elder require assistance with mobility?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="mobility" value="walker"
            (change)="onCheckboxChange($event,'mobilityAssistance')"> Walker</label>
        <label><input type="checkbox" id="mobility" value="wheelchair"
            (change)="onCheckboxChange($event,'mobilityAssistance')"> Wheelchair</label>
        <label><input type="checkbox" id="mobility" value="bedridden"
            (change)="onCheckboxChange($event,'mobilityAssistance')"> Bedridden</label>
        <label><input type="checkbox" id="mobility" value="other"
            (change)="onCheckboxChange($event,'mobilityAssistance')"> Other:</label>
        <input type="text" name="mobility-other" placeholder="Specify other assistance"
          formControlName="otherMobilityDetails">
      </div>

      <label>Can they perform daily activities independently?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="activities" value="bathing"
            (change)="onCheckboxChange($event,'independentlyActivities')"> Bathing</label>
        <label><input type="checkbox" id="activities" value="dressing"
            (change)="onCheckboxChange($event,'independentlyActivities')"> Dressing</label>
        <label><input type="checkbox" id="activities" value="eating"
            (change)="onCheckboxChange($event,'independentlyActivities')"> Eating</label>
        <label><input type="checkbox" id="activities" value="toileting"
            (change)="onCheckboxChange($event,'independentlyActivities')"> Toileting</label>
      </div>

      <label>Do they need assistance with medication reminders?</label>
      <div class="radio-group">
        <label><input type="radio" id="medication-reminders" value="yes" formControlName="medicationReminders">
          Yes</label>
        <label><input type="radio" id="medication-reminders" value="no" formControlName="medicationReminders">
          No</label>
      </div>

      <!-- Nutrition & Special Dietary Needs -->
      <h2>Nutrition & Special Dietary Needs</h2>
      <label>Are there any dietary restrictions or special nutritional requirements?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="diet" value="low-salt"
            (change)="onCheckboxChange($event,'dietaryRestrictions')"> Low salt</label>
        <label><input type="checkbox" id="diet" value="diabetic"
            (change)="onCheckboxChange($event,'dietaryRestrictions')"> Diabetic diet</label>
        <label><input type="checkbox" id="diet" value="protein"
            (change)="onCheckboxChange($event,'dietaryRestrictions')"> Protein intake</label>
        <textarea id="diet-other" name="diet-other" formControlName="otherDietaryRestrictions"
          placeholder="Specify other dietary needs"></textarea>
      </div>

      <!-- Respiratory & Oxygen Support -->
      <h2>Respiratory & Oxygen Support</h2>
      <label>Does the elder suffer from Asthma?</label>
      <div class="radio-group">
        <label><input type="radio" id="asthma" value="yes" formControlName="asthmaDetails"> Yes</label>
        <label><input type="radio" id="asthma" value="no" formControlName="asthmaDetails"> No</label>
      </div>

      <label>Does the Elder require oxygen therapy?</label>
      <div class="radio-group">
        <label><input type="radio" id="oxygen-therapy" value="yes" formControlName="oxygenTherapy"> Yes</label>
        <label><input type="radio" id="oxygen-therapy" value="no" formControlName="oxygenTherapy"> No</label>
      </div>

      <label>Is the Elder using any medical devices?</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="devices" value="nebulizer"
            (change)="onCheckboxChange($event,'medicalDevices')"> Nebulizer</label>
        <label><input type="checkbox" id="devices" value="bipap" (change)="onCheckboxChange($event,'medicalDevices')">
          BiPAP</label>
        <label><input type="checkbox" id="devices" value="cpap" (change)="onCheckboxChange($event,'medicalDevices')">
          CPAP</label>
        <label><input type="checkbox" id="devices" value="oxygen-concentrator"
            (change)="onCheckboxChange($event,'medicalDevices')"> Oxygen Concentrator</label>
      </div>

      <!-- Sleep & Mental Well-being -->
      <h2>Sleep & Mental Well-being</h2>
      <label>Does the Elder have difficulty sleeping?</label>
      <div class="radio-group">
        <label><input type="radio" id="sleep" value="yes" formControlName="sleepingDifficulty"> Yes</label>
        <label><input type="radio" id="sleep" value="no" formControlName="sleepingDifficulty"> No</label>
      </div>

      <label>Has the Elder shown any signs of memory loss, confusion, or cognitive decline?</label>
      <div class="radio-group">
        <label><input type="radio" id="memory" value="yes" formControlName="memoryLoss"> Yes</label>
        <label><input type="radio" id="memory" value="no" formControlName="memoryLoss"> No</label>
      </div>

      <label>Does the Elder experience anxiety, stress, or mood changes?</label>
      <div class="radio-group">
        <label><input type="radio" id="mood" value="yes" formControlName="anxietyDetails"> Yes</label>
        <label><input type="radio" id="mood" value="no" formControlName="anxietyDetails"> No</label>
      </div>

      <!-- Family Preferences & Communication -->
      <h2>Family Preferences & Communication</h2>
      <label>Who should receive health updates about the Elder?</label>
      <input type="text" id="contact-name" name="contact-name" placeholder="Enter name"
        formControlName="healthUpdatesName">
      <input type="text" id="contact-number" name="contact-number" placeholder="Enter contact number"
        formControlName="updatesContactNo">

      <button (click)="assessmentFormSubmit()">Submit</button>
    </div>
  </form>


</div>
<div class="modal-body customModalBody" *ngIf="assessmentData?.assessmentType == 'FRM_NRS_ASMT'">
  <div class="form-container">
    <form [formGroup]="nursingAssessment_Form">
     

      <h2>Basic Information & General Well-being</h2>

      <label for="feeling">How are you feeling today? Any new concerns or discomfort?</label>
      <textarea id="feeling" name="feeling" formControlName="aboutFeelings"
        placeholder="Enter your response"></textarea>

      <label>Have you had any recent falls, dizziness, or weakness?</label>
      <div class="yes-no">
        <label><input type="radio" formControlName="aboutWeakness" id="falls" value="yes"> Yes</label>
        <label><input type="radio" formControlName="aboutWeakness" id="falls" value="no"> No</label>
      </div>
      <textarea id="falls-details" name="falls-details" formControlName="detailsWeakness"
        placeholder="If yes, please provide details"></textarea>

      <label>Do you have any pain or swelling in any part of the body?</label>
      <div class="yes-no">
        <label><input type="radio" id="pain" value="yes" formControlName="aboutSwelling"> Yes</label>
        <label><input type="radio" id="pain" value="no" formControlName="aboutSwelling"> No</label>
      </div>
      <textarea id="pain-details" name="pain-details" formControlName="detailsSwelling"
        placeholder="If yes, please provide details"></textarea>

      <label>Are you experiencing any difficulty in breathing or chest discomfort?</label>
      <div class="yes-no">
        <label><input type="radio" id="breathing" value="yes" formControlName="aboutBreathing"> Yes</label>
        <label><input type="radio" id="breathing" value="no" formControlName="aboutBreathing"> No</label>
      </div>
      <textarea id="breathing-details" name="breathing-details" formControlName="detailsBreathing"
        placeholder="If yes, please provide details"></textarea>

      <label>Have you had any recent changes in appetite, digestion, or bowel movements?</label>
      <div class="yes-no">
        <label><input type="radio" id="appetite" value="yes" formControlName="aboutDigestion"> Yes</label>
        <label><input type="radio" id="appetite" value="no" formControlName="aboutDigestion"> No</label>
      </div>
      <textarea id="appetite-details" name="appetite-details" formControlName="detailsDigestion"
        placeholder="If yes, please provide details"></textarea>

      <label>Are you feeling more tired or fatigued than usual?</label>
      <div class="yes-no">
        <label><input type="radio" id="fatigue" value="yes" formControlName="aboutFatigued"> Yes</label>
        <label><input type="radio" id="fatigue" value="no" formControlName="aboutFatigued"> No</label>
      </div>
      <textarea id="fatigue-details" name="fatigue-details" formControlName="detailsFatigued"
        placeholder="If yes, please provide details"></textarea>

      <label>Are you experiencing any stress, anxiety, or changes in mood?</label>
      <div class="yes-no">
        <label><input type="radio" id="stress" value="yes" formControlName="aboutStress"> Yes</label>
        <label><input type="radio" id="stress" value="no" formControlName="aboutStress"> No</label>
      </div>
      <textarea id="stress-details" name="stress-details" formControlName="detailsStress"
        placeholder="If yes, please provide details"></textarea>

      <label>How is your sleep quality? Any difficulty falling or staying asleep?</label>
      <textarea id="sleep" name="sleep" formControlName="detailsSleepQuality"
        placeholder="Enter your response"></textarea>

      <label>Are you taking all your prescribed medications on time? Any missed doses?</label>
      <div class="yes-no">
        <label><input type="radio" id="medication" value="yes" formControlName="aboutMedications"> Yes</label>
        <label><input type="radio" id="medication" value="no" formControlName="aboutMedications"> No</label>
      </div>
      <textarea id="medication-details" name="medication-details" formControlName="missedMedications"
        placeholder="If yes, please provide details"></textarea>

      <label>Have you noticed any changes in your memory or confusion recently?</label>
      <div class="yes-no">
        <label><input type="radio" id="memory" value="yes" formControlName="aboutConfusion"> Yes</label>
        <label><input type="radio" id="memory" value="no" formControlName="aboutConfusion"> No</label>
      </div>
      <textarea id="memory-details" id="memory-details" formControlName="detailsConfusion"
        placeholder="If yes, please provide details"></textarea>

      <h2>Vital Signs Monitoring</h2>

      <div class="vital-signs">
        <label for="systolic">Systolic Blood Pressure (mmHg)</label>
        <input type="number" id="systolic" name="systolic" formControlName="bpSystolic">

        <label for="diastolic">Diastolic Blood Pressure (mmHg)</label>
        <input type="number" id="diastolic" name="diastolic" formControlName="bpDiastolic">

        <label for="heart-rate">Heart Rate (bpm)</label>
        <input type="number" id="heart-rate" name="heart-rate" formControlName="heartRate">

        <label for="respiratory-rate">Respiratory Rate (breaths per minute)</label>
        <input type="number" id="respiratory-rate" name="respiratory-rate" formControlName="respiratoryRate">

        <label for="oxygen-saturation">Oxygen Saturation (%)</label>
        <input type="number" id="oxygen-saturation" name="oxygen-saturation" formControlName="oxygenSaturation">

        <label for="temperature">Temperature (°C / °F)</label>
        <input type="text" id="temperature" name="temperature" formControlName="temperature">

        <label for="weight">Weight (kg)</label>
        <input type="number" id="weight" name="weight" formControlName="weight" (change)="bmiCalculator()">

        <label for="height">Height (cm)</label>
        <input type="number" id="height" name="height" formControlName="height" (change)="bmiCalculator()">

        <label for="bmi">BMI (calculated)</label>
        <input type="number" id="bmi" name="bmi" readonly formControlName="bmi">
      </div>

      <button (click)="assessmentFormSubmit()">Submit</button>

    </form>
  </div>
</div>
<div class="modal-body customModalBody" *ngIf="assessmentData?.assessmentType == 'FRM_PHY_ASMT'">
  <div class="form-container">
    <form [formGroup]="physioAssessment_Form">
      <!-- <h1>Patient Questionnaire</h1> -->

      <h2>Patient Details</h2>

      <label for="name">Name:</label>
      <input type="text" id="name" name="name" placeholder="Enter your name" disabled formControlName="name">

      <label for="age">Age:</label>
      <input type="number" id="age" name="age" placeholder="Enter your age" disabled formControlName="age">

      <label for="gender">Gender:</label>
      <select id="gender" name="gender" formControlName="gender" disabled>
        <option value="">Select</option>
        <option value="2">Male</option>
        <option value="1">Female</option>
        <option value="3">Other</option>
      </select>

      <label for="date-of-visit">Date of Visit:</label>
      <input type="date" id="date-of-visit" name="date-of-visit" formControlName="dateOfVisit">

      <h2>Chief Complaint and History</h2>

      <label>Primary reason for visit:</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="reason" value="pain-relief"
            (change)="onCheckboxChange($event,'reasonForVisit')"> Pain relief</label>
        <label><input type="checkbox" id="reason" value="post-surgery"
            (change)="onCheckboxChange($event,'reasonForVisit')"> Post-surgery recovery</label>
        <label><input type="checkbox" id="reason" value="other" (change)="onCheckboxChange($event,'reasonForVisit')">
          Other (Specify):</label>
        <input type="text" name="reason-other" placeholder="Specify other reason" formControlName="otherReasonForVisit">
      </div>

      <label for="pain-level">Pain level (1-10):</label>
      <input type="number" id="pain-level" name="pain-level" min="1" max="10" placeholder="Enter pain level"
        formControlName="painLevel">
      <textarea id="pain-notes" name="pain-notes" placeholder="Additional notes" formControlName="painNotes"></textarea>

      <label>Duration of the problem:</label>
      <div class="radio-group">
        <label><input type="radio" id="duration" value="<1 month" formControlName="durationProblem"> Less than 1
          month</label>
        <label><input type="radio" id="duration" value="1-6 months" formControlName="durationProblem"> 1-6
          months</label>
        <label><input type="radio" id="duration" value=">6 months" formControlName="durationProblem"> More than 6
          months</label>
      </div>
      <textarea id="duration-notes" name="duration-notes" placeholder="Additional notes"
        formControlName="otherDuration"></textarea>

      <label>Relevant medical history:</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="medical-history" value="joint-replacement"
            (change)="onCheckboxChange($event,'medicalHistory')"> Joint replacement</label>
        <label><input type="checkbox" id="medical-history" (change)="onCheckboxChange($event,'medicalHistory')"
            value="arthritis"> Arthritis</label>
        <label><input type="checkbox" id="medical-history" value="other"
            (change)="onCheckboxChange($event,'medicalHistory')"> Other (Specify):</label>
        <input type="text" name="medical-history-other" placeholder="Specify other history"
          formControlName="otherMedicalHis">
      </div>

      <h2>Functional Assessment</h2>

      <label>Ability to perform daily activities:</label>
      <div class="radio-group">
        <label><input type="radio" id="daily-activities" value="independent" formControlName="dailyActivities">
          Independent</label>
        <label><input type="radio" id="daily-activities" value="requires-help" formControlName="dailyActivities">
          Requires help (Specify):</label>
        <input type="text" name="daily-activities-help" placeholder="Specify help required"
          formControlName="activitiesDetails">
      </div>
      <textarea id="daily-activities-notes" name="daily-activities-notes" placeholder="Additional notes"
        formControlName="activitiesNotes"></textarea>

      <label>Pain during movement:</label>
      <div class="radio-group">
        <label><input type="radio" id="pain-movement" value="yes" formControlName="movementPain"> Yes (Specify
          movement):</label>
        <label><input type="radio" id="pain-movement" value="no" formControlName="movementPain"> No</label>
        <input type="text" name="pain-movement-details" placeholder="Specify movement"
          formControlName="detailsMovementPain">
      </div>
      <textarea id="pain-movement-notes" name="pain-movement-notes" placeholder="Additional notes"
        formControlName="movementPainNotes"></textarea>

      <label for="range-of-motion">Range of motion:</label>
      <textarea id="range-of-motion" name="range-of-motion" placeholder="Normal or Restricted (Specify for each joint)"
        formControlName="rangeMotion"></textarea>

      <div class="grid">
        <label for="upper-limb-strength">Muscle strength - Upper limbs (graded 0-5):</label>
        <input type="number" id="upper-limb-strength" name="upper-limb-strength" min="0" max="5"
          formControlName="upperLimbsStrength">

        <label for="lower-limb-strength">Muscle strength - Lower limbs (graded 0-5):</label>
        <input type="number" id="lower-limb-strength" name="lower-limb-strength" min="0" max="5"
          formControlName="lowerLimbsStrength">
      </div>
      <textarea id="strength-notes" name="strength-notes" placeholder="Additional notes"
        formControlName="strengthNotes"></textarea>

      <h2>Goals and Plan</h2>

      <label>Primary therapy goals:</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="therapy-goals" value="mobility"
            (change)="onCheckboxChange($event,'therapyGoals')"> Mobility improvement</label>
        <label><input type="checkbox" id="therapy-goals" value="strength"
            (change)="onCheckboxChange($event,'therapyGoals')"> Strength building</label>
        <label><input type="checkbox" id="therapy-goals" value="pain-relief"
            (change)="onCheckboxChange($event,'therapyGoals')"> Pain relief</label>
      </div>
      <textarea id="therapy-goals-notes" name="therapy-goals-notes" placeholder="Additional notes"
        formControlName="detailsTherapyGoals"></textarea>

      <label>Recommended therapy:</label>
      <div class="checkbox-group">
        <label><input type="checkbox" id="recommended-therapy" value="stretching"
            (change)="onCheckboxChange($event,'recommendedTherapy')"> Stretching</label>
        <label><input type="checkbox" id="recommended-therapy" value="strength-building"
            (change)="onCheckboxChange($event,'recommendedTherapy')"> Strength-building</label>
        <label><input type="checkbox" id="recommended-therapy" value="other"
            (change)="onCheckboxChange($event,'recommendedTherapy')"> Other:</label>
        <input type="text" name="recommended-therapy-other" placeholder="Specify other therapy"
          formControlName="detailsRecommendedTherapy">
      </div>
      <textarea id="recommended-therapy-notes" name="recommended-therapy-notes" placeholder="Additional notes"
        formControlName="recommendedTherapyNotes"></textarea>

      <label>Frequency of sessions:</label>
      <div class="radio-group">
        <label><input type="radio" id="frequency" value="daily" formControlName="sessionsFrequency"> Daily</label>
        <label><input type="radio" id="frequency" value="weekly" formControlName="sessionsFrequency"> Weekly</label>
        <label><input type="radio" id="frequency" value="other" formControlName="sessionsFrequency"> Other:</label>
        <input type="text" name="frequency-other" placeholder="Specify frequency"
          formControlName="detailsSessionsFrequency">
      </div>
      <textarea id="frequency-notes" name="frequency-notes" placeholder="Additional notes"
        formControlName="frequencyNotes"></textarea>

      <button (click)="assessmentFormSubmit()">Submit</button>

    </form>
  </div>
</div>